import type { CompanySettingsUI } from '@/hooks/useCompaniesData';

/**
 * Mock companies data for demo mode
 */
export const mockCompanies: CompanySettingsUI[] = [
  {
    id: '1',
    name: 'Acme Corporation',
    status: 'active',
    logo: undefined,
    description: 'Leading technology solutions provider',
    integrationStatus: 'connected',
    userCount: 24,
    createdAt: '2024-01-15T10:00:00Z',
    lastSyncedAt: '2025-06-10T08:45:00Z',
    companyGroupId: 10,
    code: 'ACME001',
    currencyCode: 'GBP',
    linkedSubscriptionId: 'sub-1',
    linkedSubscriptionName: 'Demo Instance 1',
    linkedProductName: 'Financials',
    isMultiCompany: true,
    externalCompanyName: undefined,
  },
  {
    id: '1a',
    name: 'Acme Corporation — Trading',
    status: 'active',
    logo: undefined,
    integrationStatus: 'connected',
    userCount: 8,
    createdAt: '2024-01-15T10:00:00Z',
    lastSyncedAt: '2025-06-10T08:45:00Z',
    companyGroupId: 10,
    code: 'ACME001-T',
    currencyCode: 'GBP',
    linkedSubscriptionId: 'sub-1',
    linkedSubscriptionName: 'Demo Instance 1',
    linkedProductName: 'Financials',
    linkedSubLedger: 'SL1',
    isMultiCompany: true,
    externalCompanyName: 'TRADING',
  },
  {
    id: '1b',
    name: 'Acme Corporation — Holdings',
    status: 'active',
    logo: undefined,
    integrationStatus: 'connected',
    userCount: 5,
    createdAt: '2024-01-15T10:00:00Z',
    lastSyncedAt: '2025-06-10T08:45:00Z',
    companyGroupId: 10,
    code: 'ACME001-H',
    currencyCode: 'GBP',
    linkedSubscriptionId: 'sub-1',
    linkedSubscriptionName: 'Demo Instance 1',
    linkedProductName: 'Financials',
    linkedSubLedger: 'SL2',
    isMultiCompany: true,
    externalCompanyName: 'HOLDINGS',
  },
  {
    id: '2',
    name: 'Global Industries Ltd',
    status: 'active',
    logo: undefined,
    description: 'Manufacturing and distribution',
    integrationStatus: 'connected',
    userCount: 18,
    createdAt: '2024-02-20T14:30:00Z',
    lastSyncedAt: '2025-06-09T16:20:00Z',
    companyGroupId: 20,
    code: 'GLOB002',
    currencyCode: 'EUR',
    linkedSubscriptionName: 'Demo Instance 2',
    linkedProductName: 'DimensionsvNext',
    linkedSubLedger: 'SL3',
    isMultiCompany: false,
  },
  {
    id: '3',
    name: 'Tech Innovations Inc',
    status: 'pending_setup',
    logo: undefined,
    description: 'Software development company',
    integrationStatus: 'none',
    userCount: 12,
    createdAt: '2024-03-10T09:15:00Z',
    lastSyncedAt: undefined,
    companyGroupId: 30,
    code: 'TECH003',
    currencyCode: 'USD',
    linkedSubscriptionName: undefined,
    linkedProductName: undefined,
    linkedSubLedger: undefined,
    isMultiCompany: false,
  },
];
